import clock from '../../assets/clock.png';

const TimeLineStepper = ({ data, isTimeLineLoading, imgdata, getimgs, handleencounters }) => {
  const hasData = data && Object.keys(data).length > 0;

  return (
    <div className="min-h-[300px] min-w-[300px] max-h-[500px] border border-gray-300 bg-white rounded-lg overflow-hidden flex flex-col">
      
      {/* Header */}
      <div className="border-b border-[#2C5282] bg-[linear-gradient(0deg,_rgba(44,82,130,0.80)_0%,_rgba(44,82,130,0.80)_100%)] text-white p-2 flex items-center justify-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M9.99984 18.3333C14.6022 18.3333 18.3332 14.6024 18.3332 9.99999C18.3332 5.39762 14.6022 1.66666 9.99984 1.66666C5.39746 1.66666 1.6665 5.39762 1.6665 9.99999C1.6665 14.6024 5.39746 18.3333 9.99984 18.3333Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 5V10L13.3333 11.6667" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span className="text-md font-semibold">Patient Timeline</span>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto p-4 space-y-6 custom-scrollbar">
        {isTimeLineLoading ? (
          <div className="min-h-[300px] flex items-center justify-center">
            <span className="text-gray-500 text-sm animate-pulse">Retrieving data...</span>
          </div>
        ) : !hasData && !imgdata.length ? (
          <div className="min-h-[300px] flex items-center justify-center">
            <span className="text-gray-500 text-sm">No data available</span>
          </div>
        ) : (
          <div className="relative border-l-2 border-[#E5E7EB] pl-4">
            {[
              ...(hasData ? Object.entries(data).map(([date, details]) => ({
                type: 'data',
                date,
                details,
              })) : []),
              ...(imgdata?.map((item) => ({
                type: 'img',
                date: item.date,
                details: item,
              })) || [])
            ]
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((entry, idx) => {
                const [year, month, day] = entry.date.split('-');
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const formattedDate = `${monthNames[+month - 1]} ${+day}`;

                if (entry.type === 'data') {
                  const { details } = entry;
     
                  let buttonText = '';
                  if (details?.title) buttonText = details.title;
                  else if (details?.encounter_summary?.type === 'visit') buttonText = 'Visit';
                  else if (details?.labs) buttonText = 'Labs'
                   else if (details?.images) buttonText = details?.images

                  return (
                    <div key={`entry-${idx}`} className="mb-8 flex items-start gap-8">
                      <div className="w-3 h-3 absolute left-[-7px] mt-2 bg-[#22C55E] rounded-full"></div>
                      <div className="flex w-full justify-between items-center">
                        <p className="text-gray-700 font-bold">{formattedDate}</p>
                        {buttonText ? (
                          <button 
                            onClick={() => getimgs({ date: entry.date, details })}
                            className="mt-1 bg-[#DBEAFE] text-[#15803D] px-3 py-1 rounded-full text-sm font-normal"
                          >
                            {buttonText}
                          </button>
                        ) : (
                          <span className="text-gray-500 text-sm">No Action</span>
                        )}
                      </div>
                    </div>
                  );
                } else {
                  const { details } = entry;
                  return (
                    <div key={`entry-${idx}`} className="mb-8 flex items-start gap-8">
                      <div className="w-3 h-3 absolute left-[-7px] mt-2 bg-[#22C55E] rounded-full"></div>
                      <div className="flex w-full justify-between items-center">
                        <p className="text-gray-700 font-bold">{formattedDate}</p>
                        <button
                          onClick={() => handleencounters(details)}
                          className="mt-1 bg-[#DBEAFE] text-[#15803D] px-3 py-1 rounded-full text-sm font-normal max-w-[150px] truncate"
                          title={details.title}
                        >
                          {details.title || 'Document'}
                        </button>
                      </div>
                    </div>
                  );
                }
              })}
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeLineStepper;
